import React from 'react';
import moment from 'moment-timezone';

import { useUserData } from './helpers';

const RefundStatsItem = ({ stat }) => {
  const refundUser = useUserData({ userId: stat.userId });

  if (!refundUser) {
    return null;
  }

  const refundDate = moment(stat.refundedAt).format('DD/MM/YYYY');
  const refundTime = moment(stat.refundedAt).format('hh:mm A');

  return (
    <div className="m-2">
      <p className="is-size-4 has-text-weight-semibold">
        Date: {refundDate} at {refundTime} Refund Amount: $
        {parseFloat(stat.refundAmount).toFixed(2)}
      </p>
      <p className="is-size-4 has-text-weight-normal">
        Refunded By: {refundUser}
      </p>
      <p className="is-size-4 has-text-weight-normal">
        Reason: {stat.refundReason}
      </p>
      <p className="is-size-4 has-text-weight-normal">Note: {stat.note}</p>
    </div>
  );
};

const RefundStats = ({ stats }) =>
  stats.map(st => <RefundStatsItem key={st.refundedAt} stat={st} />);

export default RefundStats;
